import { css } from '@emotion/react'

export const styles = () => ({
  modal: {
    main: css``,
  },
})
